<template>
  <div>
    <v-row :style="`height:${frameHeight}px;`" class="mt-0">
      <v-col cols="12" md="3" class="primary pa-0 d-none d-md-block">
        <!-- <v-img
          src="/login.png"
          cover
          :style="`height:${frameHeight}px;`"
        >
        </v-img> -->
      </v-col>
      <v-col cols="12" md="6" :style="`height:${frameHeight}px;`" class="pa-0 elevation-0 align-center" v-if="installed">
        <v-card class="align-center pa-2 pt-12 elevation-0" :style="`height:${frameHeight-3}px;`">
          <v-card class="text-center py-5 elevation-2 align-center">
            <img v-if="site.logo" :src="site.logo" height="70" alt="">
            <span v-if="!site.logo" class="headline">{{site.name}}</span>
          </v-card>
          <v-card-text class="text-center" v-if="!session_token && !cap && false">
            <v-form>
              <v-text-field 
                append-icon="person" 
                name="email" 
                :label="i18n.email" 
                type="text" 
                @keypress.enter="login"
                :class="`${arabic?'arFont':'enFont'}`"
                v-model="user.email">
              </v-text-field>
              <v-text-field 
                append-icon="lock" 
                name="password" 
                :label="i18n.password" 
                id="password" 
                @keypress.enter="login"
                :class="`${arabic?'arFont':'enFont'}`"
                type="password" 
                v-model="user.password">
              </v-text-field>
            </v-form>
            <span v-if="error" :class="`${ arabic ? 'arFont' : '' } error--text`">{{ i18n[error] }}</span>
          </v-card-text>
          <v-card-actions v-if="!session_token && !cap && false">
            <v-btn  text @click="switchLanguage('en')" v-if="language == 'ar'" class="mb-1">
            english
            </v-btn>
            <v-btn  text v-if="language == 'en'" @click="switchLanguage('ar')" :class="`mb-1 arFont`">
              عربي
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login" large :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{i18n.login}}</v-btn>
          </v-card-actions>
          <v-card-text class="text-center" v-show="!session_token && cap && false">
            <div id="CaptchaImageCode" class="CaptchaTxtField">
              <canvas id="CapCode" class="capcode" width="300" height="80"></canvas>
            </div>
            <v-text-field 
              append-icon="lock" 
              name="captcha" 
              :label="i18n.captcha" 
              id="captcha" 
              @keypress.enter="verifyCaptcha"
              :class="`${arabic?'arFont':'enFont'}`"
              v-model="captcha">
            </v-text-field>
            <span v-if="error" :class="`${ arabic ? 'arFont' : '' } error--text`">{{ i18n[error] }}</span>
          </v-card-text>
          <v-card-actions v-if="!session_token && cap && false">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="verifyCaptcha()" large :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{ i18n.send }}</v-btn>
          </v-card-actions>
          <v-card-text class="text-center" v-if="session_token && false">
              <v-text-field 
                append-icon="textsms" 
                :label="i18n.SMSCode" 
                :name="i18n.SMSCode" 
                :class="`${arabic?'arFont':'enFont'}`"
                @keypress.enter="verify"
                type="code" 
                v-model="sms_code">
              </v-text-field>
            <span v-if="error" :class="`${ arabic ? 'arFont' : '' } error--text`">{{ i18n[error] }}</span>
          </v-card-text>
          <v-card-actions v-if="session_token && false">
            <v-spacer></v-spacer>
            {{ REMOVE }}
            <v-btn color="primary" @click="verify" large :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{ i18n.send }}</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn  text block @click="switchLanguage('en')" v-if="language == 'ar'" class="mb-1">
            english
            </v-btn>
            <v-btn  text block v-if="language == 'en'" @click="switchLanguage('ar')" :class="`mb-1 arFont`">
              عربي
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn color="error" block x-large @click="OauthLogin(0)" large :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{ i18n.login }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      
      <v-col cols="12" md="3" class="primary pa-0 d-none d-md-block">
        <!-- <v-img
          src="/login.png"
          cover
          :style="`height:${frameHeight}px;`"
        >
        </v-img> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import Settings from './settings.vue'
const fireapi = 'https://us-central1-aramcco-crm.cloudfunctions.net/main';

export default {
  components:{ Settings },
  data: () => ({
    frameHeight:0,
    loading: false,
    forgetpass:false,
    error:null,
    resetStat:null,
    errorTimeOUt:null,
    user: {
      email: null,
      password: null
    },
    session_token:null,
    sms_code:null,
    REMOVE:null,
    installed:true,
    magic:false,
    cap:false,
    captchaCheck:null,
    captcha:null,
  }),

  methods: {
    async OauthLogin (p) {
      const redirectURL = await this.$store.dispatch('fethOAuthRedirectURL', { provider: 'google' });
      return window.location.replace(redirectURL);
      this.loading = true
      var provider
      switch (p) {
        case 0:
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        default:
          break;
      }
      firebase.auth().signInWithPopup(provider).then( async (u) => {
        console.log(u)
        let a = u.additionalUserInfo
        let n = a.profile
        let nu = {
          'provider': a.providerId,
          'name': n.name,
          'email': n.email,
          'scopes': n.granted_scopes,
          'image': n.picture,
          'verified_email': n.verified_email ? 1 : 0,
        }
        if(a.isNewUser) {
          let r = await axios.post(`${this.api}/user`, nu, headers).then(x=>x.data)
          console.log(r);
          if(!r.error) {
            this.loading = false
            this.$emit('snackbarNotification', `${this.i18n.accountCreated}`, 'error')
          }
        } else {
          let r = await axios.post(`${fireapi}/loginCRM`, { token: u.user.ma }, { headers }).then(x => x.data)
          console.log(r)
          if(!r.error) {
            this.loading = false
            this.$store.state.centralLogin = true
            this.$store.state.access_token = r.access_token
            this.setCookie('_MJC', r.access_token, 1)
            this.$store.state.user = r.user
            if(r.user && r.user.role == 'admin')  {
              this.goTo('/leads')
            } else if(r.user && r.user.role == 'superadmin')  {
              this.goTo('/campaigns')
            } else if(r.user.role.includes('de_'))  {
              this.goTo('/bw-campaigns')
            } else {
              this.goTo('/leads')
            }
          } else if (r.error == 'unuthorized_access') {
            this.loading = false
            this.$emit('snackbarNotification', `${this.i18n.accountCreated}`, 'error')
            this.error = this.i18n.accountCreated
            this.resetError()
          } else {
            this.loading = false
            this.$emit('snackbarNotification', `${r.error}`, 'error')
            this.error = r.error
            this.resetError()
          }
        }
      })
      .catch((error) => {
        this.error = error.message
        this.loading = false
        this.$emit('snackbarNotification', `Error -> Contact Admin`, 'error')
        this.resetError()
      });
    },
    async install() {
      await this.firstLogin('')
    },
    async installMagic() {
      await this.firstLogin('magic-')
    },
    async firstLogin(pre){
      new Promise(async (res, rej)=>{
        this.loading = true
        let allowed = ['mcit.gov.sa', 'yesser.gov.sa', 'ndu.gov.sa', 'evotik.com']
        if(!this.user.email.includes(allowed[0]) && !this.user.email.includes(allowed[1]) && !this.user.email.includes(allowed[2]) && !this.user.email.includes(allowed[3])) {
          this.error = 'domain_not_allowed'
          this.resetError()
          this.loading = false
          return true
        } else {
          console.log(JSON.stringify(this.user))
          let a = await axios.post(`${this.api}/users/${pre}first-login`, this.user, headers).then(x=>x.data)
          if(!a.error) {
            this.$store.state.centralLogin = true
            this.$store.state.access_token = a.access_token
            this.setCookie('_MJC', a.access_token, 1)
            this.$store.state.user = a.user
            this.loading = false
            res(true)
          } else {
            this.session_token = null
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.resetError()
            res(false)
          }
        }
      })
    },
    async checkInstall(){
      let a = await axios.get(`${this.api}/install-check`).then(x=>x.data)
      if(!a || !a.length) {
        this.installed = false
        this.switchLanguage('en')
      }
      console.log(a)
    },
    goTo(path) {
      this.$router.push(path)
    },
    resetPass(){
      console.log(this.user)
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    async login () {
      this.loading = true
      let allowed = ['mcit.gov.sa', 'yesser.gov.sa', 'ndu.gov.sa', 'evotik.com']
      if(!this.user.email.includes(allowed[0]) && !this.user.email.includes(allowed[1]) && !this.user.email.includes(allowed[2]) && !this.user.email.includes(allowed[3])) {
        this.error = 'domain_not_allowed'
        this.resetError()
        this.loading = false
        return true
      } else {
        let a = await axios.post(`${this.api}/users/login`, this.user, headers).then(x=>x.data)
        if(a.session_token) {
          console.log(a)
          this.session_token = a.session_token
          this.loading = false
          this.REMOVE = a.REMOVE.Status.message
        } else {
          this.session_token = null
          this.error = a.error
          this.resetError()
          this.loading = false
        }
        console.log(a)
      }
    },
    resetError(){
      clearTimeout(this.errorTimeOUt)
      this.errorTimeOUt = setTimeout(x=>{ this.error = null }, 4000)
    },
    async verify() {
      this.loading = true
      let data = {
        code:this.sms_code,
        email:this.user.email,
        session_token:this.session_token
      }
      try {
        let a = await axios.post(`${this.api}/user/auth`, data, headers).then(x=>x.data)
        console.log(a)
        if(!a.error) {
          this.$store.state.centralLogin = true
          this.$store.state.access_token = a.access_token
          this.setCookie('_MJC', a.access_token, 1)
          this.$store.state.user = a.user
          await this.$store.dispatch('loadSettings')
          if(a.user && a.user.role == 'admin')  {
            this.goTo('/campaigns')
          } else if(a.user && a.user.role == 'superadmin')  {
            this.goTo('/campaigns')
          } else if(a.user.role.includes('de_'))  {
            this.goTo('/bw-campaigns')
          } else {
            this.goTo('/campaigns')
          }
          this.loading = false
        } else {
          if( a.error == 'max_retries' ) {
            this.cap = true
            this.session_token = null
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.CreateCaptcha()
            this.resetError()
          } else if( a.error == 'wrong_code' ){
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.resetError()
          } else if( a.error == 'expired' ){
            this.session_token = null
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.resetError()
          } else if( a.error == 'user_does_not_exist' ){
            this.session_token = null
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.resetError()
          } else {
            this.session_token = null
            this.error = a.error
            this.sms_code = null
            this.$emit('snackbarNotification', `${this.i18n[a.error]}`, 'error')
            this.loading = false
            this.resetError()
          }
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    verifyCaptcha() {
      console.log(this.captchaCheck)
      console.log(this.captcha)
      if( this.captcha == this.captchaCheck ) {
        this.cap = false
        this.captchaCheck = null
        this.captcha  = null
        this.user.email  = null
        this.user.password  = null
      } else {
        this.captchaCheck = null
        this.captcha  = null
        this.error = 'wrong_captcha'
        this.$emit('snackbarNotification', `${this.i18n['wrong_captcha']}`, 'error')
        this.resetError()
        this.CreateCaptcha()
      }
    },
    CreateCaptcha() {
      var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
      var i;
      for (i = 0; i < 6; i++) {
        var a = alpha[Math.floor(Math.random() * alpha.length)];
        var b = alpha[Math.floor(Math.random() * alpha.length)];
        var c = alpha[Math.floor(Math.random() * alpha.length)];
        var d = alpha[Math.floor(Math.random() * alpha.length)];
        var e = alpha[Math.floor(Math.random() * alpha.length)];
        var f = alpha[Math.floor(Math.random() * alpha.length)];
      }
      let cd = a + ' ' + b + ' ' + c + ' ' + d + ' ' + e + ' ' + f;
      this.captchaCheck = cd.split(' ').join('')
      let ac = document.getElementById('CaptchaImageCode')
      var c = document.getElementById("CapCode")
      var ctx = c.getContext("2d"),
          x = c.width / 2,
          img = new Image();
      
      img.src = "/pattern.jpg";
      img.onload = function () {
          var pattern = ctx.createPattern(img, "repeat");
          ctx.fillStyle = pattern;
          ctx.fillRect(0, 0, c.width, c.height);
          ctx.font="46px Roboto Slab";
          ctx.fillStyle = '#ccc';
          ctx.textAlign = 'center';
          ctx.setTransform (1, -0.12, 0, 1, 0, 15);
          ctx.fillText(cd,x,55);
      };
    },
    enLanguage(){
      this.$emit('changeLang', 'en')
    },
    arLanguage(){
      this.$emit('changeLang', 'ar')
    },
    switchLanguage(l) {
      this.$store.state.language = l
      if(l=='ar') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
    },
    setH(){
      let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
      this.frameHeight = h
    },
  },
  props: {
    
  },
  watch:{
    api(){}
  },
  computed:{
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    api(){
      return this.$store.state.settings.apiBase
    }
  },
  created(){
    
  },
  mounted(){
    this.setH()
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
